import React, { useContext, useEffect, useState } from "react";
import style from "../style/FirstLogin.module.scss";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { AuthContext } from "../contexts/AuthContext";
import { useMutation, useQuery, useQueryClient } from "react-query";
import CountDown from "../components/CountDown";
import apiClient from "../libraries/ApiClient";
import { v4 as uuidv4 } from "uuid";

const CssTextField = styled((props) => <TextField {...props} fullWidth />)(
  ({ theme }) => ({
    "& .MuiFilledInput-root": {
      border: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "&:before": {
        border: "none",
      },
      "&:after": {
        border: "none",
      },
      "&.Mui-focused": {
        backgroundColor: "transparent",
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-error": {
        borderColor: "#EB4D3D",
      },
    },
  })
);
const CssButton = styled(Button)({
  fontSize: 16,
  background: "#057AFF",
  "&:disabled": {
    border: "1px solid #818181",
    color: "#818181",
    background: "#E0E0E0",
  },
  "&:hover": {
    cursor: "pointer",
  },
});

function FirstLogin() {
  const codeRule = /^-?\d*\.?\d*$/;
  const navigate = useNavigate();
  const queryClint = useQueryClient();

  // const { mailValue } = useContext(LoginContext);
  const { myAuth, setMyAuth } = useContext(AuthContext);
  const { Account, AccountRowId } = myAuth;
  // console.log(Account,AccountRowId);
  // console.log(Account);

  const [code, setCode] = useState("");
  const [vaild, setVaild] = useState(false);

  const [timeLeft, setTimeLeft] = useState(180); // 180 seconds = 3 minutes
  const [isRunning, setIsRunning] = useState(true);

  const onChangeCodeValue = (e) => {
    const value = e.target.value;
    const vaildateValue = (value) => codeRule.test(value);
    // console.log(vaildateValue(value));
    // console.log(value);
    let a = value.split("");

    if (vaildateValue(value) && a.length <= 4) {
      setCode(e.target.value);
    }
    if (a.length === 4) {
      setVaild(true);
    }
  };

  const sendMailData = async ({ queryKey }) => {
    const [_, Account, AccountRowId] = queryKey;
    // console.log(Account);
    //console.log(AccountRowId);
    const data = {
      Data: {
        Identifier: Account,
        AccountRowId: AccountRowId,
      },
    };

    const res = await apiClient.postAes("api/otp/send/account/Security", data);
    return res;
  };

  const sendMailAgainData = async ({ Account, AccountRowId }) => {
    const data = {
      Data: {
        Identifier: Account,
        AccountRowId: AccountRowId,
      },
    };

    const res = await apiClient.postAes("api/otp/send/account/Security", data);
    return res?.data?.Code;
  };

  const sendCodeData = async ({ Account, AccountRowId, code }) => {
    const data = {
      Data: {
        AccountRowId: AccountRowId,
        Identifier: Account,
        OtpCode: code,
      },
    };

    const res = await apiClient.postAes(
      "api/otp/validation/account/Security",
      data
    );
    return res?.data;
  };

  const { data, isLoading } = useQuery(
    ["sendMailData", Account, AccountRowId],
    sendMailData
  );
  const { data: codeResData, mutate } = useMutation(sendCodeData);
  //console.log(codeResData);

  useEffect(() => {
    if (+codeResData?.Code === 0) {
      //console.log(codeResData);
      if (codeResData?.Data === null) {
        alert(codeResData?.Message);
      } else {
        const LocalstorageData = {
          authorized: true,
          AccountRowId: codeResData?.Data?.AccountRowId,
          Name: codeResData?.Data?.Name,
          Account: codeResData?.Data?.Account,
          Token: codeResData?.Data?.Token,
          Menu: codeResData?.Data?.Menus,
          SelfIdentities:
            codeResData?.Data?.Identities?.landseed_zonedefense_tbc,
          OtherIdentities: codeResData?.Data?.Identities?.other_zonedefense_tbc,
          Hospital: codeResData?.Data?.OrganizationName,
          HospitalCode: codeResData?.Data?.OrganizationCode,
          IsAdmin: codeResData?.Data?.IsAdmin,
          // IsOtherHospital: IsOtherHospitalAccount,
        };
        // console.log(LocalstorageData);
        localStorage.setItem("auth", JSON.stringify(LocalstorageData));
        const actionUuid = uuidv4();
        localStorage.setItem("actionUuid", actionUuid);
        setMyAuth({ ...LocalstorageData, authorized: true });
        alert("成功登入");
        navigate("/ReferralDataList");
      }
    } else if (+codeResData?.Code === 1) {
      alert(codeResData?.Message);
    }
  }, [codeResData]);

  const { data: mailAgainData, mutate: sendAgainMutate } =
    useMutation(sendMailAgainData);

  useEffect(() => {
    if (+mailAgainData === 0) {
      alert("已重新發送");
    }
  }, [mailAgainData]);

  return (
    <div className={style.FirstLogin_body}>
      <div className={style.FirstLogin_background}></div>
      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1921 273"
        className={style.triangle}
      >
        <polygon fill="#fff" points="0,273 1921,273 1921,0 "></polygon>
      </svg>
      <div className={style.FirstLogin_form_body}>
        <div className={style.logo}>
          <img src="./end_logo.svg" alt="" style={{ width: "20%" }} />
        </div>
        <div className={style.FirstLogin_form}>
          <div className={style.FirstLogin_form_top}>
            <div className={style.FirstLogin_title}>請完成首次登入驗證</div>
            <div className={style.FirstLogin_little_title}>
              {`系統已將驗證碼寄到${Account}`}
            </div>
          </div>
          <div className={style.input_content}>
            <div className={style.input_mail}>
              <CssTextField
                label="請輸入驗證碼(4碼數字)"
                variant="filled"
                onChange={onChangeCodeValue}
                value={code}
                // error={hasMailError ? true : false}
                style={{ width: "100%" }}
              />
            </div>
            <div className={style.btn}>
              <CssButton
                variant="contained"
                onClick={() => {
                  mutate({ Account, AccountRowId, code });
                }}
                disabled={!vaild}
              >
                確認
              </CssButton>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                }}
              >
                您還沒收到驗證碼嗎?
                {timeLeft === 0 && (
                  <div
                    style={{
                      textDecoration: "none",
                      color: "#057AFF",
                      textAlign: "center",
                      padding: "16px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      sendAgainMutate({ Account, AccountRowId });
                      setIsRunning(true);
                      setTimeLeft(180);
                    }}
                  >
                    再次發送驗證碼
                  </div>
                )}
                <CountDown
                  setTimeLeft={setTimeLeft}
                  setIsRunning={setIsRunning}
                  isRunning={isRunning}
                  timeLeft={timeLeft}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FirstLogin;
